// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"ccda2a7e","787":"a0f43e0d"}[chunkId] + ".chunk.js";
};